import { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import graphHandler from "../../../Apollo/graphHandler";
import CustomButton from "../../../components/Button/CustomButton";
import {
  ADD_TEMPLATE_GQL,
  UPDATE_TEMPLATE_GQL,
} from "../../../Apollo/AdminServices/MailRuleReportRequest";
import CreateMediaFileUpload from "../../../components/MediaFileUpload/CreateMediaFileUpload";
import { TemplateType } from "../../../constants";

export default function CreateMailTemplate({ isOpen, setOpen, refresh }) {
  const [template_id, setId] = useState("");
  // const [isTemplate, setIsTemplate] = useState(false);
  const form = useFormik({
    initialValues: {},
    validationSchema: template_id ? DocValidation : validation,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  const onClose = () => {
    // if (template_id && isTemplate == true) {
    //   return;
    // }
    form.resetForm();
    form.setValues({});
    setOpen();
    setId("");
  };
  const onSubmit = async (values) => {
    if (values.template_id) return updateMail(values);
    const { template_name, template_code, template_type } = values;
    let addReq = { template_name, template_code, template_type };
    try {
      const { data } = await graphHandler().invoke(
        ADD_TEMPLATE_GQL,
        { addReq },
        1,
        false
      );
      refresh();
      if (
        data &&
        data.AddTemplate &&
        data.AddTemplate.template &&
        data.AddTemplate.template.template_id
      ) {
        toast.success("Now you can upload your document");
        setId(data.AddTemplate.template.template_id);
        form.setFieldValue(
          "template_id",
          data.AddTemplate.template.template_id
        );
        // setIsTemplate(true)
      } else {
        onClose();
      }
      form.setSubmitting(false);
    } catch (error) {
      console.error("Create Rule", error);
      form.setSubmitting(false);
    }
  };
  const updateMail = async (values) => {
    // setIsTemplate(false)
    const { template_document, template_id } = values;
    if (!template_document || !template_document.url) {
      form.setSubmitting(false);
      return toast.warn("Template document is required");
    }
    let update_request = {
      template_id,
      template_document: {
        name: template_document.name,
        document_type: template_document.type,
        url: template_document.url,
        is_mobile: false,
      },
    };
    try {
      await graphHandler().invoke(
        UPDATE_TEMPLATE_GQL,
        { update_request },
        1,
        true
      );
      refresh();
      onClose();
      form.setSubmitting(false);
    } catch (error) {
      console.error("Create Rule", error);
      form.setSubmitting(false);
      // setIsTemplate(false)
    }
  };
  const handleError = () => {
    if (Object.keys(form.errors).length > 0) {
      toast.error(form.errors[Object.keys(form.errors)[0]]);
    }
  };

  return (
    <Modal
      toggle={onClose}
      isOpen={isOpen}
      centered
      keyboard={false}
      scrollable
      size="xl"
    >
      <div className="modal-header">
        <button type="button" className="close" onClick={onClose}>
          <span aria-hidden="true">&times;</span>
        </button>
        <h5 className="modal-title">Create Template</h5>
      </div>
      <ModalBody className="pt-0">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 form-group  ">
              <label
                htmlFor="template_name"
                className="col-form-label w-100 mb-2"
              >
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="template_name"
                name="template_name"
                value={
                  form.values && form.values.template_name
                    ? form.values.template_name
                    : ""
                }
                onChange={(e) =>
                  form.setFieldValue(
                    "template_name",
                    e.target.value.trimStart()
                  )
                }
                onBlur={(e) => {
                  form.setFieldTouched("template_name", true);
                  form.setFieldValue(
                    "template_name",
                    e.target.value.replace(/\s+/g, " ").trim()
                  );
                }}
                disabled={template_id}
              />
              <small className="text-danger">
                {form.touched.template_name && form.errors.template_name
                  ? form.errors.template_name
                  : ""}
              </small>
            </div>
            <div className="col-md-12 form-group">
              <label
                htmlFor="template_code"
                className="col-form-label w-100 mb-2"
              >
                Code
              </label>
              <input
                {...form.getFieldProps("template_code")}
                type="text"
                className="form-control "
                id="template_code"
                disabled={template_id}
                value={
                  form.values.template_code ? form.values.template_code : ""
                }
              />
              <small className="text-danger align-self-end">
                {form.touched.template_code &&
                form.errors &&
                form.errors.template_code
                  ? form.errors.template_code
                  : ""}
              </small>
            </div>
            <div className="col-md-12 form-group">
              <label
                htmlFor="template_type"
                className="col-form-label w-100 mb-2"
              >
                Type
              </label>
              <select
                className="custom-select"
                name="template_type"
                id="template_type"
                onChange={form.handleChange}
                value={
                  form.values.template_type ? form.values.template_type : ""
                }
                onBlur={form.handleBlur}
                disabled={template_id}
              >
                <option key="Select" hidden>
                  Select
                </option>
                {TemplateType.map((data, i) => (
                  <option key={i} value={data.value} hidden={!data.value}>
                    {data.name}
                  </option>
                ))}
              </select>
              <small className="text-danger align-self-end">
                {form.touched.template_type &&
                form.errors &&
                form.errors.template_type
                  ? form.errors.template_type
                  : ""}
              </small>
            </div>
            {template_id && (
              <div className="col-12 form-group">
                <label className="col-form-label w-100">Document</label>
                <div className="col-form-label w-100 row">
                  <CreateMediaFileUpload
                    id="template_document"
                    name="template_document"
                    formik={form}
                    mediaType="Document"
                    contentId={template_id}
                    contentType="TEMPLATE"
                  />
                </div>
                <small className="text-danger align-self-end">
                  {form.errors.template_document
                    ? form.errors.template_document
                    : ""}
                </small>
              </div>
            )}
            <CustomButton
              type="button"
              className="btn btn-primary btn-outline-success float-right btn-add-domain"
              disabled={
                (template_id
                  ? !form.values ||
                    !form.values.template_document ||
                    !form.values.template_document.url ||
                    form.values.template_document.isUpload
                  : false) ||
                !form.isValid ||
                form.isSubmitting
              }
              onClick={
                form.isValid && Object.keys(form.values).length !== 0
                  ? form.handleSubmit
                  : handleError
              }
            >
              {template_id ? "Update" : "Create"}
            </CustomButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

const validation = Yup.object().shape({
  template_name: Yup.string().required("Enter name"),
  template_code: Yup.string().required("Enter code"),
  template_type: Yup.string().required("Select type"),
});

const DocValidation = Yup.object().shape({
  template_document: Yup.object()
    .shape({
      url: Yup.string(),
    })
    .required("Document is required"),
});
